/* THIS FILE IS GENERATED. DO NOT EDIT */

import dynamic from 'next/dynamic'

export const LabradorComponentsPreview = {
  JwVideoTeaser: dynamic(() => import("base/components/labrador/JwVideo/Teaser/preview"), { ssr: false }),
}
